import { render, staticRenderFns } from "./PresetForm.vue?vue&type=template&id=00bbeb2c&scoped=true&"
import script from "./PresetForm.vue?vue&type=script&lang=js&"
export * from "./PresetForm.vue?vue&type=script&lang=js&"
import style0 from "./PresetForm.vue?vue&type=style&index=0&id=00bbeb2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bbeb2c",
  null
  
)

export default component.exports